// Common data utilities for invoicing and payment

import { LedgerAccount } from '@models/next/LedgerAccount';
import { createStrings } from '@utils/local';

export type LedgerType = 'invoice' | 'payment';

export type LedgerDivisionName = 'A' | 'B' | 'C' | 'D';

export interface LedgerDivision {
  type: LedgerType;
  debit: LedgerAccount;
  credit: LedgerAccount;
}

export const ledgerDivisions: Record<LedgerDivisionName, LedgerDivision> = {
  A: {
    type: 'invoice',
    debit: '未収立替金',
    credit: '立替金',
  },
  B: {
    type: 'invoice',
    debit: '売掛金',
    credit: '請求在庫',
  },
  C: {
    type: 'payment',
    debit: '立替金',
    credit: '未払立替金',
  },
  D: {
    type: 'payment',
    debit: '支払在庫',
    credit: '買掛金',
  },
};

export const ledgerStrings = createStrings({
  ja: {
    division: '区分',
    errorDebitNotFound(debit: string) {
      return `借方${JSON.stringify(debit)}は見つかりません。`;
    },
  },
});
